import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpen, Download, Heart, Sparkles, Palette, Users } from 'lucide-react';
const benefits = [{
  icon: <BookOpen className="w-6 h-6 text-texto" data-id="element-25" />,
  title: 'Información clara y cercana',
  description: 'Textos escritos en un lenguaje accesible, sin jerga médica complicada, pensados para que los sientas como una charla entre amigas.',
  color: 'bg-rosa'
}, {
  icon: <Download className="w-6 h-6 text-texto" data-id="element-26" />,
  title: 'Recursos digitales prácticos',
  description: 'Descargá tus ebooks al instante y leelos a tu propio ritmo desde cualquier dispositivo, donde y cuando quieras.',
  color: 'bg-celeste'
}, {
  icon: <Heart className="w-6 h-6 text-texto" data-id="element-27" />,
  title: 'Temas reales que muchas viven',
  description: 'Abordamos las experiencias que a menudo se silencian, dándoles el espacio y la importancia que merecen.',
  color: 'bg-durazno'
}, {
  icon: <Sparkles className="w-6 h-6 text-texto" data-id="element-28" />,
  title: 'Mirada humana y sensible',
  description: 'Cada página está impregnada de empatía y respeto por los procesos individuales de cada mujer.',
  color: 'bg-lila'
}, {
  icon: <Palette className="w-6 h-6 text-texto" data-id="element-29" />,
  title: 'Diseño estético y fácil de leer',
  description: 'Maquetación cuidada, tipografías amables y colores suaves que invitan a la calma y la introspección.',
  color: 'bg-beige'
}, {
  icon: <Users className="w-6 h-6 text-texto" data-id="element-30" />,
  title: 'Contenido pensado para acompañar',
  description: 'Más que libros, son herramientas de contención emocional para que no te sientas sola en tus procesos.',
  color: 'bg-rosa'
}];
export function Benefits() {
  return <section className="py-24 md:py-32 bg-crema" data-id="element-31">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-32">
        <FadeIn className="text-center mb-16" data-id="element-33">
          <h2 className="font-serif text-4xl md:text-5xl text-texto mb-6" data-id="element-34">
            Lo que vas a encontrar en este espacio
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12" data-id="element-35">
          {benefits.map((benefit, index) => <FadeIn key={index} delay={index * 0.1} className="flex flex-col items-center text-center group" data-id="element-36">
              <div className={`w-16 h-16 rounded-2xl ${benefit.color} flex items-center justify-center mb-6 transform group-hover:scale-110 transition-transform duration-300 shadow-sm`} data-id="element-37">
                {benefit.icon}
              </div>
              <h3 className="font-serif text-2xl text-texto mb-3" data-id="element-38">
                {benefit.title}
              </h3>
              <p className="font-sans text-textoSuave leading-relaxed" data-id="element-39">
                {benefit.description}
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}